<template>
  <v-app>
    <Navbar></Navbar>
    <v-content class="mx-2 mt-4 mb-4">
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import Navbar from '@/components/Navbar'
import AuthenticationService from '@/services/AuthenticationService'
import consola from 'consola'

import config from '@/config/'

export default {
  name: 'App',
  components: {
    Navbar
  },
  data () {
    return {
      //
    }
  },
  async mounted () {
    let verified = true
    // check version
    consola.info('[App.vue] checking version ...')
    if (this.$store.state.version !== config.version) {
      verified = false
      consola.warn(`[App.vue] version mis-match client side version: ${this.$store.state.version}; required version: ${config.version}.`)
    } else {
      consola.success(`[App.vue] version match: ${this.$store.state.version}`)
    }

    // check login status
    consola.info('[App.vue] checking login status ... ')
    if (!this.$store.state.isUserLoggedIn) {
      verified = false
      // if (this.$store.state.route.name !== 'lesson-templates') {
      //   this.$router.push({ name: 'lesson-templates' })
      // }
    } else { // user is not logged in
      consola.success('[App.vue] User logged in and is tutor')
    }

    // verify token
    consola.info(`[App.vue] verify token ${'...'}`)
    if (this.$store.state.token) {
      const res = await AuthenticationService.verifyToken(this.$store.state.token)
      if (!res.data.result) {
        consola.warn(`[App.vue] token is not valid ${'.'}`)
        verified = false
      }
    }

    // if any of above not pass, clear the storage and direct to login page.
    if (!verified) {
      consola.info(`[App.vue] one of the above not pass, clear storage ${'...'}`)
      // 清理 store
      this.$store.dispatch('setToken', null)
      this.$store.dispatch('setAccount', null)
      this.$store.dispatch('setVersion', null)
      this.$store.dispatch('setQueryingState', null)
      // 跳转至登录页面
      if (this.$store.state.route.name !== 'login') {
        this.$router.push({ name: 'login' })
      }
    } else {
      consola.success(`[App.vue] all pass, re-direct to lesson-template ${'.'}`)
      if (this.$store.state.route.name === 'login-mobile') {
        this.$router.push({ name: 'lesson-templates' })
      }
    }
  }
}
</script>

<style>
#app {
  font-family: 微软雅黑, 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale
}
</style>
